<template>
  <div
    class="html-container"
    :class="{ 'state-changes': !showChanges }"
    :style="{ zoom: modal ? modalFontSize : fontSize }"
  >
    <slot>
      Нема садржаја странице
    </slot>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HtmlDiv",
  props: {
    modal: {
      default: false,
    },
    content: {
      default: "",
    },
    showChanges: {
      default: false,
    },
  },
  computed: {
    ...mapState(["fontSize", "modalFontSize"]),
  },
};
</script>

<style scoped>
.html-container {
  max-width: 100% !important;
}

.html-container::v-deep {
  font-size: 100%;
  overflow-x: unset !important;
  width: 100%;
  padding-right: 17px;
}

.html-container::v-deep {
  font-family: Verdana, Arial, Helvetica, sans-serif;
  font-size: 0.75rem;
  overflow-x: unset !important;
  width: 100%;
}

.html-container::v-deep p {
  font-family: Verdana, Arial, sans-serif;
  font-size: 0.75rem;
  line-height: 0.875rem;
  margin-bottom: 0;
  white-space: normal;
  text-indent: 32px;
}

.html-container::v-deep p * {
  font-family: Verdana, Arial, sans-serif;
  font-size: 0.75rem;
  line-height: 0.875rem;
  margin-bottom: 0;
  white-space: normal;
}

.html-container::v-deep .resize-type-em p {
  font-family: Verdana, Arial, sans-serif;
  font-size: 0.833em;
  line-height: 1.4 !important;
  margin-bottom: 0;
  white-space: normal;
  text-indent: 32px;
}

/* Zakonodavni deo */
.html-container::v-deep p.odluka-zakon,
.html-container::v-deep p.naslov,
.html-container::v-deep p.ukaz,
.html-container::v-deep p.ukaz-naslov,
.html-container::v-deep p.broj {
  font-weight: bold;
  text-align: center;
}

.html-container::v-deep p.odluka-zakon {
  margin: 15px 0 15px 0;
}

.html-container::v-deep p.clan {
  text-align: center;
  font-weight: normal;
  margin: 22px 0 8px 0;
}

.html-container::v-deep p.potpis {
  text-align: right;
}

.html-container::v-deep p.broj-grupa {
  font-weight: bold;
  text-align: center;
}

.html-container::v-deep p.kraj-grupa {
  text-align: right;
}

/*   ---   */

.html-container::v-deep table {
  border: 0 none;
  width: 100%;
  border-collapse: collapse;
}

.html-container::v-deep td,
.html-container::v-deep tr,
.html-container::v-deep th {
  border: 0 none;
}

.html-container::v-deep td {
  padding: 3px;
}

/* Oglasni deo */
.html-container::v-deep p.firma {
  text-align: center;
}

.html-container::v-deep p.resenje {
  text-align: center;
}

.html-container::v-deep td p {
  text-indent: 0px;
}

.html-container::v-deep .STILOVI_MML {
  text-align: center;
  font-size: 16pt !important;
  text-transform: uppercase;
  color: #0e9606;
}

.html-container::v-deep .akt {
  text-indent: 2.4rem;
  text-align: justify;
}

.html-container::v-deep .aktSUPA-MML {
  text-indent: 2.4rem;
  text-align: justify;
  margin: 0 0 0 0;
  line-height: 1rem;
}

.html-container::v-deep .naslov_MML {
  font-size: 0.92rem;
  font-weight: bold;
  text-align: center;
  margin: 0 0 0 0;
  line-height: 1.2rem;
}

/*MML 3.2.2017 ukinuta margina*/
.html-container::v-deep .bold_MML {
  font-weight: bold;
  text-align: center;
  margin: 0 0 0 0;
}

/*novo kreirano 3.2.2017*/
.html-container::v-deep .bolditalikLeft {
  font-weight: bold;
  font-style: italic;
  text-indent: 32px;
  text-align: justify;
  margin: 0 0 0 0;
}

.html-container::v-deep .boldLeft {
  font-weight: bold;
  text-indent: 32px;
  text-align: justify;
  margin: 0 0 0 0;
}

.html-container::v-deep .italik_MML {
  font-style: italic;
  text-align: center;
  margin: 0 0 0 0;
}

/*novo kreirano 3.2.2017*/
.html-container::v-deep .italikLeft {
  font-style: italic;
  text-align: justify;
  margin: 0 0 0 0;
}

.html-container::v-deep .underline_MML {
  text-decoration: underline;
  text-align: center;
}

.html-container::v-deep .underlineLeft {
  text-decoration: underline;
}

.html-container::v-deep .spacija_MML {
  letter-spacing: 1.8px;
  text-align: center;
  margin: 0 0 0 0;
}

.html-container::v-deep .centar_MML {
  text-align: center;
  margin: 0 0 0 0;
}

/*novo kreirano 3.2.2017*/
.html-container::v-deep .footnote {
  font-size: smaller;
  font-style: italic;
  text-align: justify;
}

/*MML 17.08.2016*/

.html-container::v-deep .superscript {
  vertical-align: super;
  font-size: smaller;
}

.html-container::v-deep .subscript {
  vertical-align: sub;
  font-size: smaller;
}

.html-container::v-deep .tabela-podnaslov {
  border: 1px solid #808080;
  text-align: center;
  margin: 0 0 0 0;
  background-color: #d8d8d8;
  text-transform: uppercase;
  padding: 5px 0 5px 0;
  font-family: Verdana !important;
}

.html-container::v-deep .tabela-izvor {
  text-indent: 32px;
  border: 1px solid #808080;
  background-color: #d8d8d8;
  font-style: italic;
  font-family: Verdana !important;
  padding: 20px 0 20px 0 !important;
}

.html-container::v-deep .tabela-izvor td p {
  text-indent: 32px;
  font-size: 100%;
  font-family: Verdana !important;
}

.html-container::v-deep .tabela-citat {
  text-indent: 32px !important;
  border: 1px solid #808080;
  background-color: #f5f5f5;
  font-size: 90%;
  font-style: italic;
  line-height: 100%;
  font-family: Verdana !important;
}

.html-container::v-deep .tabela-citat td p {
  text-indent: 32px;
  font-size: 100%;
  font-family: Verdana !important;
}

.html-container::v-deep .tabela-sa-borderom-MML {
  border: 1px solid #808080;
  border-collapse: collapse;
  background-color: #f5f5f5;
  width: 100%;
  font-family: Verdana !important;
  font-size: 0.75rem !important;
  line-height: 0.875rem;
  margin-bottom: 0;
  text-indent: 32px;
  font-style: italic;
}

.html-container::v-deep .tabela-sa-borderom-MML td {
  border: 1px solid #808080;
  padding: 1px 1px 1px 3px;
  background-color: #f5f5f5;
  font-family: Verdana !important;
  font-size: 0.75rem !important;
  line-height: 0.875rem;
  margin-bottom: 0;
  text-indent: 32px;
  font-style: italic;
}

.html-container::v-deep .tabela-sa-borderom-MML td p {
  text-indent: 32px;
  text-align: justify;
  font-family: Verdana !important;
  font-size: 0.75rem !important;
  line-height: 0.875rem;
  margin-bottom: 0;
  font-style: italic;
}

.html-container::v-deep .tabela-autor {
  border: 1px solid #808080;
  text-align: right;
  font-style: italic;
  margin: 0 0 0 0;
  background-color: #f5f5f5;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: Verdana !important;
}

.html-container::v-deep .STILOVI_SUDSKA_PRAKSA {
  text-align: center;
  font-size: 16pt;
  text-transform: uppercase;
}

.html-container::v-deep .sentenca_naslov {
  font-weight: bold;
  margin-top: 18px;
  margin-bottom: 18px;
  text-align: center !important;
}

.html-container::v-deep .izvod_iz_presude {
  font-weight: bold;
  text-align: center !important;
  margin: 0 0 0 0;
}

.html-container::v-deep .sentenca {
  border: 1px solid #000;
  border-collapse: collapse;
  text-indent: 2.4rem;
  font-weight: bold;
}

.html-container::v-deep .sentenca td {
  border: 1px solid #000;
  padding: 1px 1px 1px 3px;
  text-indent: 32px;
  margin-top: 32px;
}

.html-container::v-deep .sentenca td p {
  font-weight: bold;
  text-indent: 32px;
  text-align: justify;
}

.html-container::v-deep .tabela-izvod {
  border: 1px solid #000;
  text-indent: 32px !important;
}

.html-container::v-deep .STILOVI_REGISTAR {
  text-align: center;
  font-size: 16pt;
  text-transform: uppercase;
}

.html-container::v-deep .bold {
  font-weight: bold;
  text-align: center;
  margin: 22px 0 8px 0;
}

.html-container::v-deep .italik {
  font-style: italic;
  text-align: center;
  margin: 22px 0 8px 0;
}

.html-container::v-deep .underline {
  text-decoration: underline;
  text-align: center;
  margin: 22px 0 8px 0;
}

.html-container::v-deep .spacija {
  letter-spacing: 1.8px;
  text-align: center;
  margin: 22px 0 8px 0;
}

.html-container::v-deep .centar {
  text-align: center;
  margin: 15px 0 8px 0;
}

.html-container::v-deep .potpis {
  text-align: right;
}

.html-container::v-deep .tabela-sa-borderom {
  border: 1px solid #000;
  border-collapse: collapse;
}

.html-container::v-deep .tabela-sa-borderom td {
  border: 1px solid #000;
  padding: 1px 1px 1px 3px;
}

.html-container::v-deep .tabela-sa-borderom td p {
  text-indent: 0px;
}

.html-container::v-deep .tabela-bez-bordera {
  border: none;
}

.html-container::v-deep .redakcijskipreciscentekst {
  border: medium thin Black;
  text-align: right;
  font-weight: bold;
  border-style: solid;
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 2px 5px;
  border-width: 1px;
  margin-right: 5px;
  margin-top: 5px;
  text-indent: 0px !important;
}

.html-container::v-deep .redakcijskipreciscentekst {
  font-family: Verdana, Arial, sans-serif;
  font-size: 0.75rem !important;
  line-height: 0.875rem;
  margin-bottom: 0;
  white-space: normal;
}

#primaryContentHtml {
  position: relative;
}

.html-container::v-deep .nevazeciakt {
  border: medium thin Black;
  text-align: right;
  margin-top: 40px;
  font-weight: bold;
  border-style: solid;
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 2px 5px;
  border-width: 1px;
  margin-right: 5px;
  color: red;
  text-indent: 0px !important;
}

.html-container::v-deep .v2-clan-left-1 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-1 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-1 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-1:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-2 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-2 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-2 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-2:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-3 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-3 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-3 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-3:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-4 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-4 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-4 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-4:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-5 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-5 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-5 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-5:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-6 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-6 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-6 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-6:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-7 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-7 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-7 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-7:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-8 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-8 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-8 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-8:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-9 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-9 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-9 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-9:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-10 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-10 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-10 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-10:after {
  content: none;
}

.html-container::v-deep .v2-underline-left {
  text-decoration: underline;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-underline-left {
  font-weight: normal;
}

.state-changes::v-deep .v2-underline-left * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-1 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-1 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-1 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-1:after {
  content: none;
}

.state-changes::v-deep .v2-spacija-left-1:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-2 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-2 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-2 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-2:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-3 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-3 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-3 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-3:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-1 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-1 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-1 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-1:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-2 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-2 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-2 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-2:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-3 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-3 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-3 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-3:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-1 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-1 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-1 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-1:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-2 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-2 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-2 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-2:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-3 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-3 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-3 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-3:after {
  content: none;
}

.html-container::v-deep .v2-clan-1 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-1 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-1 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-clan-1:after {
  content: none;
}

.html-container::v-deep .v2-clan-2 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-2 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-2 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-clan-2:after {
  content: none;
}

.html-container::v-deep .v2-clan-3 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-3 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-3 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-clan-3:after {
  content: none;
}

.html-container::v-deep .v2-underline {
  text-decoration: underline;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-underline {
  font-weight: normal;
}

.state-changes::v-deep .v2-underline * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-1 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-1 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-1 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-spacija-1:after {
  content: none;
}

.html-container::v-deep .v2-spacija-2 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-2 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-2 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-spacija-2:after {
  content: none;
}

.html-container::v-deep .v2-spacija-3 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-3 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-3 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-spacija-3:after {
  content: none;
}

.html-container::v-deep .v2-italik-1 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-1 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-1 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-italik-1:after {
  content: none;
}

.html-container::v-deep .v2-italik-2 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-2 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-2 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-italik-2:after {
  content: none;
}

.html-container::v-deep .v2-italik-3 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-3 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-3 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-italik-3:after {
  content: none;
}

.html-container::v-deep .v2-bold-1 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-1 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-1 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-bold-1:after {
  content: none;
}

.html-container::v-deep .v2-bold-2 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-2 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-2 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-bold-2:after {
  content: none;
}

.html-container::v-deep .v2-bold-3 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-3 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-3 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-bold-3:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-1 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-1 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-1 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-1:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-2 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-2 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-2 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-2:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-1 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-1 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-1 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-1:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-2 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-2 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-2 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-2:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-3 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-3 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-3 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-3:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-1 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-1 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-1 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-1:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-2 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-2 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-2 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-2:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-3 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-3 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-3 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-3:after {
  content: none;
}

.html-container::v-deep .v2-naslov-1 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-1 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-1 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-naslov-1:after {
  content: none;
}

.html-container::v-deep .v2-naslov-2 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-2 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-2 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-naslov-2:after {
  content: none;
}

.html-container::v-deep .v2-naslov-3 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-3 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-3 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-naslov-3:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-1 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-1 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-1 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-1:after {
  content: "*";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-1:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-2 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-2 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-2 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-2:after {
  content: "**";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-2:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-3 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-3 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-3 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-3:after {
  content: none;
}

.html-container::v-deep .pronadjen {
  background-color: #ff0 !important;
  display: inline-block !important;
  text-indent: 0px;
}

.html-container::v-deep .story p {
  white-space: normal;
}

.html-container::v-deep .story p.f {
  text-indent: 0;
  font-style: italic;
  position: relative;
  bottom: 4px;
}

.html-container::v-deep .story * > img {
  max-width: calc(100% - 50px);
  max-width: -webkit-calc(100% - 50px);
  max-width: -moz-calc(100% - 50px);
  overflow-y: hidden;
  image-orientation: from-image;
}

.html-container::v-deep .eksponent {
  font-size: 0.83rem;
  vertical-align: super;
  color: #66c;
  font-weight: bold;
}

.html-container::v-deep .strongEksponent {
  vertical-align: super;
  color: #66f;
  font-weight: bold;
}

.html-container::v-deep .extraStrongEksponent {
  font-size: 1.17rem;
  vertical-align: super;
  color: #99f;
  font-weight: bold;
}

.html-container::v-deep .indekas {
  font-size: 0.83rem;
  vertical-align: sub;
  color: #6c6;
  font-style: italic;
}

.html-container::v-deep .strongIndekas {
  font-weight: normal !important;
  vertical-align: sub;
  color: #6f6;
  font-style: italic;
}

.html-container::v-deep .extraStrongIndekas {
  font-size: 1.17rem;
  vertical-align: sub;
  color: #9f9;
  font-style: italic;
}

.html-container::v-deep .subareaOutputPanel {
  font-family: Arial, Verdana, sans-serif;
}

.html-container::v-deep .sadrzajApstrakt {
  color: #484848;
  font-family: Arial, Helvetica, sans-serif;
  padding: 2px 0px;
  font-style: normal;
  text-align: left;
  font-size: 0.625rem;
}

.html-container::v-deep .sadrzajApstrakt1 {
  color: #484848;
  font-family: Arial, Helvetica, sans-serif;
  padding: 2px 0 2px 28px;
  font-style: italic;
  text-align: left;
  font-size: 0.6875rem;
}

.html-container::v-deep .sadrzajApstrakt2 {
  color: #484848;
  font-family: Arial, Helvetica, sans-serif;
  padding: 2px 0px 2px 48px;
  font-style: italic;
  text-align: left;
  font-size: 0.6875rem;
}

/*div.lawDisplay p { text-indent: 23px; }*/
.html-container::v-deep .potpis {
  text-align: right;
}

.html-container::v-deep .rich-mp-content-table {
  border-spacing: 0;
  padding: 0;
  border: 0px;
  height: 100%;
  width: 100%;
}

.html-container::v-deep .rich-mpnl-header-cell {
  height: 30px;
  font-family: Arial, Verdana, sans-serif;
  font-size: 12;
  text-align: left;
  background-repeat: repeat-x;
  color: White;
}

.html-container::v-deep .rich-mpnl-text {
  color: #000;
  font-family: Arial, Verdana, sans-serif;
  font-size: 13px;
  font-weight: bold;
}

.html-container::v-deep .rich-mpnl-header {
  height: 30px;
  line-height: 30px;
  font-family: Arial, Verdana, sans-serif;
  text-align: left;
  background-position: left top;
  background-repeat: repeat-x;
  background-color: green;
  color: #fff;
  border-style: none;
  padding: 2px 2px 2px 6px;
  vertical-align: middle;
}

.html-container::v-deep .rich-mpnl-body {
  padding: 3px;
  background-color: #ffffff;
}

.html-container::v-deep .noborder {
  border-style: none;
  width: 100%;
  height: 100%;
  vertical-align: top;
}

.html-container::v-deep .searchbar {
  padding: 0;
  text-align: right;
  vertical-align: middle;
  height: 20px;
  width: 100%;
}

.html-container::v-deep .searchbar .links {
  display: inline;
  float: left;
  position: relative;
  width: 960px;
}

.html-container::v-deep .searchbar .links .regLinks {
  display: inline;
  float: left;
  position: relative;
  width: 127px;
  line-height: 12px;
  color: #028002;
  text-align: center;
  text-decoration: none;
  border-top: 1px solid #e3e3e3;
  border-bottom: 1px solid #e5e5e5;
  background-color: #e9e9e9;
  background-image: linear-gradient(to bottom, #e9e9e9 0%, #d6d6d6 100%);
}

.html-container::v-deep .rich-table-row {
  color: Blue;
}

.html-container::v-deep .priloziTabColumn {
  border-style: none;
  color: #000;
  font-family: Arial, Verdana, sans-serif;
  font-size: 11px;
  overflow: hidden;
  padding: 4px;
}

.html-container::v-deep .rich-table-cell {
  border-bottom: medium none;
  border-right: medium none;
}

.html-container::v-deep .searchbar .links .tab01MI {
  padding: 3px 20px;
  width: 97px;
}

.html-container::v-deep .searchbar .links .tab02PI {
  padding: 8px 0 10px;
}

.html-container::v-deep .searchbar .links .tab03MO {
  padding: 3px 0;
}

.html-container::v-deep .searchbar .links .tab04LI {
  padding: 8px 0 10px;
}

.html-container::v-deep .searchbar .links .tab05SU {
  padding: 8px 0 10px;
}

.html-container::v-deep .mediaContent {
  width: 800px;
  height: 100%;
  vertical-align: top;
  border: medium none;
}

.html-container::v-deep .priloziContent {
  width: 150px;
  height: 100%;
  vertical-align: top;
  overflow-x: hidden;
  overflow-y: auto;
}

.html-container::v-deep .priloziContent div {
  overflow: auto;
  height: 600px;
}

.html-container::v-deep .priloziTab {
  background-color: #fff;
  border-style: none none solid;
  color: #000;
  font-family: Arial, Verdana, sans-serif;
  font-size: 11px;
  text-align: left;
  width: 100%;
  border-bottom: 1px solid #c0c0c0;
}

.html-container::v-deep .sadrzajNaslov {
  border-bottom: 1px solid #c9cbcd;
  margin: 0px 0px 10px 10px;
  padding: 20px 1px 5px 5px;
  text-align: left;
  color: #1c9500;
  font-family: Arial, sans-serif;
  font-size: 20px;
  font-weight: normal;
}

.html-container::v-deep .sadrzajLista {
  margin-left: 0;
}

.html-container::v-deep .rich-panel-body {
  padding: 0;
}

.html-container::v-deep .rich-panel {
  border-style: none;
  background-color: white;
}

.html-container::v-deep .rich-page {
  width: 960px;
}

.html-container::v-deep .sadrzajRubrikeMenuStil {
  background-color: white;
  vertical-align: top;
}

.html-container::v-deep .sadrzajRubrikeMenuStilDiv {
  background-color: white;
}

.html-container::v-deep .groupPrint {
  float: right;
  position: relative;
  right: 4px;
  top: 2px;
}

.html-container::v-deep .displayNone {
  display: none;
  margin: 0;
}

.html-container::v-deep .sadrzajTable {
  font-size: 12px;
  width: 100%;
}

.html-container::v-deep .sadrzajNadNaslov {
  color: #484848;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 10px;
  font-style: italic;
  padding: 2px 0;
  text-align: left;
}

.html-container::v-deep .sadrzajNadNaslov1 {
  color: #484848;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 10px;
  font-style: italic;
  padding: 2px 0;
  text-align: left;
}

.html-container::v-deep .sadrzajNadNaslov2 {
  color: #000;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  padding: 2px 0 2px 32px;
  text-align: left;
}

.html-container::v-deep .sadrzajPodNaslov {
  color: #484848;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 10px;
  font-style: italic;
  padding: 2px 0;
  text-align: left;
}

.html-container::v-deep .sadrzajPodNaslov1 {
  color: #484848;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 10px;
  font-style: italic;
  padding: 2px 0;
  text-align: left;
}

.html-container::v-deep .sadrzajPodNaslov2 {
  color: #484848;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 11px;
  padding: 2px 0 2px 20px;
  text-align: left;
}

.html-container::v-deep .sadrzajDiv {
  background: #ffffff none repeat scroll 0 0;
  padding: 5px;
  text-align: left;
}

.html-container::v-deep .sadrzajDiv1 {
  background: #f4f6f9 none repeat scroll 0 0;
  padding: 5px;
  text-align: left;
}

.html-container::v-deep .sadrzajDiv2 {
  background: #ffffff none repeat scroll 0 0;
  padding: 5px;
  text-align: left;
}

.html-container::v-deep .sadrzajHier {
  padding-top: 4px;
  vertical-align: top;
  width: 40px;
}

.html-container::v-deep .sadrzajHier1 {
  padding-top: 4px;
  vertical-align: top;
  width: 4%;
}

.html-container::v-deep .sadrzajHier2 {
  padding-left: 20px;
  padding-top: 4px;
  vertical-align: top;
  width: 4%;
}

.html-container::v-deep .sadrzajSubarea {
  background: #f4f6f9 none repeat scroll 0 0;
  color: #000000;
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  text-align: left;
  text-transform: uppercase;
  width: 100%;
}

.html-container::v-deep .sadrzajLink {
  color: #579681;
  cursor: pointer;
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  padding: 0;
  text-decoration: underline;
}

.html-container::v-deep .sadrzajMiddle {
  font-weight: normal;
}

.html-container::v-deep .sadrzajMiddle1 {
  font-weight: bold;
  font-family: Arial, Verdana, sans-serif;
}

.html-container::v-deep .sadrzajMiddle2 {
  font-weight: normal;
  font-family: Arial, Verdana, sans-serif;
}

.html-container::v-deep .sadrzajMiddle3 {
  font-weight: normal;
  font-family: Arial, Verdana, sans-serif;
}

.html-container::v-deep .sadrzajRight {
  font-weight: normal;
}

.html-container::v-deep .sadrzajRight1 {
  font-weight: normal;
  font-style: italic;
  font-family: Arial, Verdana, sans-serif;
}

.html-container::v-deep .sadrzajRight2 {
  font-weight: normal;
  font-style: italic;
  font-family: Arial, Verdana, sans-serif;
}

.html-container::v-deep .rich-mpnl-shadow {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  top: 4px;
  left: 4px;
  opacity: 0.1;
}

.html-container::v-deep .rich-mpnl-content {
  border-width: 1px;
  border-style: solid;
  padding: 1px;
  background-color: inherit;
}

.html-container::v-deep .rich-mpnl-trim {
  position: relative;
  z-index: 0;
}

.html-container::v-deep .rich-mpnl-ovf-hd {
  overflow: hidden;
}

.html-container::v-deep .rich-table {
  border-top: 1px solid #c0c0c0;
  border-left: 1px solid #c0c0c0;
  background-color: #fff;
  empty-cells: show;
  border-collapse: collapse;
}

.html-container::v-deep .rich-table-thead {
  border-bottom: 1px solid #c0c0c0;
}

.html-container::v-deep .rich-table-header {
  background-color: #005000;
  background-position: left top;
  background-repeat: repeat-x;
}

.html-container::v-deep .rich-table-headercell {
  border-right: 1px solid #c0c0c0;
  border-bottom: 1px solid #c0c0c0;
  padding: 4px;
  color: #fff;
  text-align: center;
  font-weight: bold;
  font-size: 11px;
  font-family: Arial, Verdana, sans-serif;
}

.html-container::v-deep .priloziTabHeader {
  background-color: #eee;
  border-style: none;
  color: #000;
  font-family: Arial, Verdana, sans-serif;
  font-size: 11px;
  font-weight: bold;
  padding: 4px 4px 4px 8px;
  text-align: left;
  letter-spacing: 1px;
  overflow-x: auto;
  overflow-y: hidden;
  cursor: default;
}

.html-container::v-deep .priloziLink {
  color: #000000;
  text-decoration: none;
}

.html-container::v-deep .sadrzajLink {
  color: #579681;
  cursor: pointer;
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  padding: 0;
  text-decoration: underline;
}

.html-container::v-deep .sadrzajRight3 {
  font-weight: normal;
  font-style: italic;
}

.html-container::v-deep .sadrzajHier3 {
  vertical-align: top;
  width: 4%;
  padding-top: 4px;
  padding-left: 42px;
}

.html-container::v-deep .sadrzajApstrakt3 {
  color: #484848;
  font-family: Arial, Helvetica, sans-serif;
  padding: 2px 0px 2px 82px;
  font-style: italic;
  text-align: left;
  font-size: 11px;
}

.html-container::v-deep .v2-odluka-zakon-4 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-4 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-4 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-4:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-5 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-5 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-5 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-5:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-6 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-6 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-6 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-6:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-7 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-7 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-7 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-7:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-8 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-8 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-8 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-8:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-9 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-9 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-9 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-9:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-10 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-10 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-10 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-10:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-11 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-11 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-11 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-11:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-12 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-12 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-12 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-12:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-13 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-13 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-13 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-13:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-14 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-14 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-14 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-14:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-15 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-15 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-15 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-15:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-16 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-16 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-16 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-16:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-17 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-17 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-17 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-17:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-18 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-18 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-18 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-18:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-19 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-19 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-19 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-19:after {
  content: none;
}

.html-container::v-deep .v2-odluka-zakon-20 {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-odluka-zakon-20 {
  text-decoration: none;
}

.state-changes::v-deep .v2-odluka-zakon-20 * {
  text-decoration: none;
}

.html-container::v-deep .v2-odluka-zakon-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-odluka-zakon-20:after {
  content: none;
}

.html-container::v-deep .v2-naslov-4 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-4 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-4 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-naslov-4:after {
  content: none;
}

.html-container::v-deep .v2-naslov-5 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-5 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-5 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-naslov-5:after {
  content: none;
}

.html-container::v-deep .v2-naslov-6 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-6 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-6 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-naslov-6:after {
  content: none;
}

.html-container::v-deep .v2-naslov-7 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-7 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-7 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-naslov-7:after {
  content: none;
}

.html-container::v-deep .v2-naslov-8 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-8 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-8 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-naslov-8:after {
  content: none;
}

.html-container::v-deep .v2-naslov-9 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-9 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-9 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-naslov-9:after {
  content: none;
}

.html-container::v-deep .v2-naslov-10 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-10 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-10 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-naslov-10:after {
  content: none;
}

.html-container::v-deep .v2-naslov-11 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-11 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-11 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-naslov-11:after {
  content: none;
}

.html-container::v-deep .v2-naslov-12 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-12 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-12 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-naslov-12:after {
  content: none;
}

.html-container::v-deep .v2-naslov-13 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-13 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-13 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-naslov-13:after {
  content: none;
}

.html-container::v-deep .v2-naslov-14 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-14 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-14 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-naslov-14:after {
  content: none;
}

.html-container::v-deep .v2-naslov-15 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-15 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-15 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-naslov-15:after {
  content: none;
}

.html-container::v-deep .v2-naslov-16 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-16 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-16 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-naslov-16:after {
  content: none;
}

.html-container::v-deep .v2-naslov-17 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-17 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-17 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-naslov-17:after {
  content: none;
}

.html-container::v-deep .v2-naslov-18 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-18 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-18 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-naslov-18:after {
  content: none;
}

.html-container::v-deep .v2-naslov-19 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-19 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-19 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-naslov-19:after {
  content: none;
}

.html-container::v-deep .v2-naslov-20 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-naslov-20 {
  text-decoration: none;
}

.state-changes::v-deep .v2-naslov-20 * {
  text-decoration: none;
}

.html-container::v-deep .v2-naslov-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-naslov-20:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-4 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-4 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-4 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-4:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-5 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-5 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-5 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-5:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-6 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-6 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-6 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-6:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-7 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-7 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-7 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-7:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-8 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-8 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-8 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-8:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-9 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-9 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-9 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-9:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-10 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-10 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-10 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-10:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-11 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-11 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-11 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-11:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-12 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-12 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-12 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-12:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-13 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-13 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-13 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-13:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-14 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-14 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-14 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-14:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-15 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-15 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-15 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-15:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-16 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-16 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-16 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-16:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-17 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-17 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-17 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-17:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-18 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-18 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-18 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-18:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-19 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-19 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-19 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-19:after {
  content: none;
}

.html-container::v-deep .v2-bold-verzal-20 {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-verzal-20 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-verzal-20 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-verzal-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-bold-verzal-20:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-4 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-4 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-4 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-4:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-5 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-5 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-5 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-5:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-6 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-6 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-6 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-6:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-7 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-7 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-7 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-7:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-8 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-8 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-8 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-8:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-9 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-9 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-9 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-9:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-10 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-10 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-10 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-10:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-11 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-11 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-11 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-11:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-12 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-12 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-12 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-12:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-13 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-13 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-13 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-13:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-14 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-14 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-14 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-14:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-15 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-15 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-15 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-15:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-16 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-16 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-16 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-16:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-17 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-17 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-17 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-17:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-18 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-18 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-18 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-18:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-19 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-19 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-19 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-19:after {
  content: none;
}

.html-container::v-deep .v2-italik-verzal-20 {
  font-style: italic;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-verzal-20 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-verzal-20 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-verzal-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-italik-verzal-20:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-3 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-3 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-3 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-3:after {
  content: "***";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-3:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-4 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-4 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-4 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-4:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-5 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-5 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-5 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-5:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-6 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-6 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-6 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-6:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-7 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-7 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-7 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-7:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-8 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-8 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-8 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-8:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-9 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-9 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-9 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-9:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-10 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-10 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-10 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-10:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-11 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-11 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-11 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-11:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-12 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-12 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-12 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-12:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-13 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-13 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-13 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-13:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-14 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-14 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-14 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-14:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-15 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-15 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-15 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-15:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-16 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-16 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-16 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-16:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-17 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-17 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-17 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-17:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-18 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-18 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-18 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-18:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-19 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-19 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-19 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-19:after {
  content: none;
}

.html-container::v-deep .v2-clan-verzal-20 {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-verzal-20 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-verzal-20 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-verzal-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-clan-verzal-20:after {
  content: none;
}

.html-container::v-deep .v2-bold-4 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-4 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-4 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-bold-4:after {
  content: none;
}

.html-container::v-deep .v2-bold-5 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-5 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-5 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-bold-5:after {
  content: none;
}

.html-container::v-deep .v2-bold-6 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-6 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-6 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-bold-6:after {
  content: none;
}

.html-container::v-deep .v2-bold-7 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-7 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-7 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-bold-7:after {
  content: none;
}

.html-container::v-deep .v2-bold-8 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-8 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-8 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-bold-8:after {
  content: none;
}

.html-container::v-deep .v2-bold-9 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-9 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-9 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-bold-9:after {
  content: none;
}

.html-container::v-deep .v2-bold-10 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-10 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-10 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-bold-10:after {
  content: none;
}

.html-container::v-deep .v2-bold-11 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-11 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-11 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-bold-11:after {
  content: none;
}

.html-container::v-deep .v2-bold-12 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-12 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-12 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-bold-12:after {
  content: none;
}

.html-container::v-deep .v2-bold-13 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-13 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-13 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-bold-13:after {
  content: none;
}

.html-container::v-deep .v2-bold-14 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-14 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-14 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-bold-14:after {
  content: none;
}

.html-container::v-deep .v2-bold-15 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-15 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-15 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-bold-15:after {
  content: none;
}

.html-container::v-deep .v2-bold-16 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-16 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-16 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-bold-16:after {
  content: none;
}

.html-container::v-deep .v2-bold-17 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-17 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-17 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-bold-17:after {
  content: none;
}

.html-container::v-deep .v2-bold-18 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-18 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-18 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-bold-18:after {
  content: none;
}

.html-container::v-deep .v2-bold-19 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-19 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-19 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-bold-19:after {
  content: none;
}

.html-container::v-deep .v2-bold-20 {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-20 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-20 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-bold-20:after {
  content: none;
}

.html-container::v-deep .v2-italik-4 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-4 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-4 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-italik-4:after {
  content: none;
}

.html-container::v-deep .v2-italik-5 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-5 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-5 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-italik-5:after {
  content: none;
}

.html-container::v-deep .v2-italik-6 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-6 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-6 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-italik-6:after {
  content: none;
}

.html-container::v-deep .v2-italik-7 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-7 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-7 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-italik-7:after {
  content: none;
}

.html-container::v-deep .v2-italik-8 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-8 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-8 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-italik-8:after {
  content: none;
}

.html-container::v-deep .v2-italik-9 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-9 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-9 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-italik-9:after {
  content: none;
}

.html-container::v-deep .v2-italik-10 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-10 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-10 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-italik-10:after {
  content: none;
}

.html-container::v-deep .v2-italik-11 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-11 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-11 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-italik-11:after {
  content: none;
}

.html-container::v-deep .v2-italik-12 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-12 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-12 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-italik-12:after {
  content: none;
}

.html-container::v-deep .v2-italik-13 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-13 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-13 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-italik-13:after {
  content: none;
}

.html-container::v-deep .v2-italik-14 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-14 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-14 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-italik-14:after {
  content: none;
}

.html-container::v-deep .v2-italik-15 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-15 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-15 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-italik-15:after {
  content: none;
}

.html-container::v-deep .v2-italik-16 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-16 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-16 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-italik-16:after {
  content: none;
}

.html-container::v-deep .v2-italik-17 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-17 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-17 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-italik-17:after {
  content: none;
}

.html-container::v-deep .v2-italik-18 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-18 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-18 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-italik-18:after {
  content: none;
}

.html-container::v-deep .v2-italik-19 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-19 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-19 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-italik-19:after {
  content: none;
}

.html-container::v-deep .v2-italik-20 {
  font-style: italic;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-20 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-20 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-italik-20:after {
  content: none;
}

.html-container::v-deep .v2-spacija-4 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-4 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-4 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-spacija-4:after {
  content: none;
}

.html-container::v-deep .v2-spacija-5 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-5 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-5 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-spacija-5:after {
  content: none;
}

.html-container::v-deep .v2-spacija-6 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-6 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-6 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-spacija-6:after {
  content: none;
}

.html-container::v-deep .v2-spacija-7 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-7 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-7 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-spacija-7:after {
  content: none;
}

.html-container::v-deep .v2-spacija-8 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-8 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-8 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-spacija-8:after {
  content: none;
}

.html-container::v-deep .v2-spacija-9 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-9 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-9 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-spacija-9:after {
  content: none;
}

.html-container::v-deep .v2-spacija-10 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-10 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-10 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-spacija-10:after {
  content: none;
}

.html-container::v-deep .v2-spacija-11 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-11 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-11 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-spacija-11:after {
  content: none;
}

.html-container::v-deep .v2-spacija-12 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-12 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-12 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-spacija-12:after {
  content: none;
}

.html-container::v-deep .v2-spacija-13 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-13 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-13 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-spacija-13:after {
  content: none;
}

.html-container::v-deep .v2-spacija-14 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-14 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-14 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-spacija-14:after {
  content: none;
}

.html-container::v-deep .v2-spacija-15 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-15 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-15 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-spacija-15:after {
  content: none;
}

.html-container::v-deep .v2-spacija-16 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-16 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-16 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-spacija-16:after {
  content: none;
}

.html-container::v-deep .v2-spacija-17 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-17 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-17 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-spacija-17:after {
  content: none;
}

.html-container::v-deep .v2-spacija-18 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-18 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-18 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-spacija-18:after {
  content: none;
}

.html-container::v-deep .v2-spacija-19 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-19 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-19 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-spacija-19:after {
  content: none;
}

.html-container::v-deep .v2-spacija-20 {
  letter-spacing: 1.2px;
  text-align: center;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-20 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-20 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-spacija-20:after {
  content: none;
}

.html-container::v-deep .v2-clan-4 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-4 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-4 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-clan-4:after {
  content: none;
}

.html-container::v-deep .v2-clan-5 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-5 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-5 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-clan-5:after {
  content: none;
}

.html-container::v-deep .v2-clan-6 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-6 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-6 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-clan-6:after {
  content: none;
}

.html-container::v-deep .v2-clan-7 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-7 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-7 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-clan-7:after {
  content: none;
}

.html-container::v-deep .v2-clan-8 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-8 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-8 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-clan-8:after {
  content: none;
}

.html-container::v-deep .v2-clan-9 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-9 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-9 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-clan-9:after {
  content: none;
}

.html-container::v-deep .v2-clan-10 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-10 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-10 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-clan-10:after {
  content: none;
}

.html-container::v-deep .v2-clan-11 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-11 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-11 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-clan-11:after {
  content: none;
}

.html-container::v-deep .v2-clan-12 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-12 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-12 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-clan-12:after {
  content: none;
}

.html-container::v-deep .v2-clan-13 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-13 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-13 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-clan-13:after {
  content: none;
}

.html-container::v-deep .v2-clan-14 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-14 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-14 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-clan-14:after {
  content: none;
}

.html-container::v-deep .v2-clan-15 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-15 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-15 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-clan-15:after {
  content: none;
}

.html-container::v-deep .v2-clan-16 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-16 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-16 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-clan-16:after {
  content: none;
}

.html-container::v-deep .v2-clan-17 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-17 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-17 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-clan-17:after {
  content: none;
}

.html-container::v-deep .v2-clan-18 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-18 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-18 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-clan-18:after {
  content: none;
}

.html-container::v-deep .v2-clan-19 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-19 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-19 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-clan-19:after {
  content: none;
}

.html-container::v-deep .v2-clan-20 {
  text-align: center;
  font-weight: bold;
  margin-top: 28px;
}

.state-changes::v-deep .v2-clan-20 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-20 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-clan-20:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-4 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-4 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-4 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-4:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-5 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-5 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-5 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-5:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-6 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-6 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-6 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-6:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-7 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-7 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-7 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-7:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-8 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-8 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-8 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-8:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-9 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-9 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-9 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-9:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-10 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-10 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-10 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-10:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-11 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-11 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-11 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-11:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-12 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-12 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-12 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-12:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-13 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-13 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-13 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-13:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-14 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-14 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-14 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-14:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-15 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-15 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-15 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-15:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-16 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-16 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-16 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-16:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-17 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-17 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-17 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-17:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-18 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-18 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-18 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-18:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-19 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-19 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-19 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-19:after {
  content: none;
}

.html-container::v-deep .v2-bold-left-20 {
  font-weight: bold;
  text-align: left;
  text-decoration: underline;
}

.state-changes::v-deep .v2-bold-left-20 {
  text-decoration: none;
}

.state-changes::v-deep .v2-bold-left-20 * {
  text-decoration: none;
}

.html-container::v-deep .v2-bold-left-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-bold-left-20:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-4 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-4 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-4 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-4:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-5 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-5 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-5 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-5:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-6 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-6 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-6 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-6:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-7 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-7 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-7 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-7:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-8 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-8 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-8 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-8:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-9 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-9 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-9 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-9:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-10 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-10 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-10 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-10:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-11 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-11 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-11 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-11:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-12 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-12 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-12 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-12:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-13 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-13 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-13 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-13:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-14 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-14 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-14 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-14:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-15 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-15 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-15 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-15:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-16 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-16 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-16 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-16:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-17 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-17 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-17 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-17:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-18 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-18 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-18 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-18:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-19 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-19 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-19 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-19:after {
  content: none;
}

.html-container::v-deep .v2-italik-left-20 {
  font-style: italic;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-italik-left-20 {
  font-weight: normal;
}

.state-changes::v-deep .v2-italik-left-20 * {
  font-weight: normal;
}

.html-container::v-deep .v2-italik-left-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-italik-left-20:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-4 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-4 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-4 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-4:after {
  content: "****";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-4:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-5 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-5 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-5 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-5:after {
  content: "*****";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-5:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-6 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-6 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-6 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-6:after {
  content: "*\2076";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-6:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-7 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-7 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-7 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-7:after {
  content: "*\2077";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-7:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-8 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-8 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-8 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-8:after {
  content: "*\2078";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-8:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-9 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-9 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-9 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-9:after {
  content: "*\2079";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-9:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-10 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-10 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-10 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-10:after {
  content: "*\00B9\2070";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-10:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-11 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-11 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-11 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-11:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-12 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-12 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-12 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-12:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-13 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-13 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-13 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-13:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-14 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-14 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-14 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-14:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-15 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-15 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-15 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-15:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-16 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-16 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-16 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-16:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-17 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-17 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-17 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-17:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-18 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-18 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-18 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-18:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-19 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-19 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-19 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-19:after {
  content: none;
}

.html-container::v-deep .v2-spacija-left-20 {
  letter-spacing: 1.2px;
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-spacija-left-20 {
  font-weight: normal;
}

.state-changes::v-deep .v2-spacija-left-20 * {
  font-weight: normal;
}

.html-container::v-deep .v2-spacija-left-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-spacija-left-20:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-11 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-11 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-11 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-11:after {
  content: "*\00B9\00B9";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-11:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-12 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-12 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-12 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-12:after {
  content: "*\00B9\00B2";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-12:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-13 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-13 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-13 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-13:after {
  content: "*\00B9\00B3";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-13:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-14 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-14 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-14 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-14:after {
  content: "*\00B9\2074";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-14:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-15 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-15 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-15 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-15:after {
  content: "*\00B9\2075";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-15:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-16 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-16 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-16 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-16:after {
  content: "*\00B9\2076";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-16:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-17 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-17 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-17 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-17:after {
  content: "*\00B9\2077";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-17:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-18 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-18 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-18 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-18:after {
  content: "*\00B9\2078";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-18:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-19 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-19 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-19 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-19:after {
  content: "*\00B9\2079";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-19:after {
  content: none;
}

.html-container::v-deep .v2-clan-left-20 {
  text-align: left;
  font-weight: bold;
}

.state-changes::v-deep .v2-clan-left-20 {
  font-weight: normal;
}

.state-changes::v-deep .v2-clan-left-20 * {
  font-weight: normal;
}

.html-container::v-deep .v2-clan-left-20:after {
  content: "*\00B2\2070";
  display: inline;
}

.state-changes::v-deep .v2-clan-left-20:after {
  content: none;
}

.state-changes::v-deep .unbold-change {
  font-weight: normal !important;
}

.state-changes::v-deep .unbold-change * {
  font-weight: normal !important;
}

.state-changes::v-deep .unitalic-change {
  text-decoration: none;
}

.state-changes::v-deep .hide-change {
  display: none !important;
}

.state-changes::v-deep .odluka-zakon {
  font-weight: bold;
  text-align: center;
  margin: 24px 0 10px 0;
  text-decoration: underline;
}

.state-menu::v-deep * {
  display: none;
}

.html-container::v-deep .force-display-block {
  display: block !important;
}

.html-container::v-deep .force-display-inline {
  display: inline !important;
}

.html-container::v-deep .force-display-none {
  display: none !important;
}

.state-menu::v-deep .act-menu-item {
  cursor: pointer;
  margin: 2px;
  text-align: left;
  color: #0000ff;
  font-weight: normal !important;
}

.state-menu::v-deep .odluka-zakon {
  cursor: pointer;
  margin: 2px !important;
  color: #0000ff;
  font-weight: normal !important;
}

.state-menu::v-deep .naslov {
  cursor: pointer;
  margin: 2px;
  color: #0000ff;
  font-weight: normal !important;
}

.state-menu::v-deep .clan {
  cursor: pointer;
  margin: 2px !important;
  text-align: left;
  color: #0000ff;
  font-weight: normal !important;
}

.state-menu::v-deep .italik {
  cursor: pointer;
  margin: 2px;
  text-align: left;
  color: #0000ff;
  letter-spacing: 0px !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-weight: normal !important;
}

.state-menu::v-deep *[class^="v2-clan-"] {
  cursor: pointer;
  margin: 2px;
  text-align: left;
  color: #0000ff;
  font-weight: normal !important;
}

.state-menu::v-deep *[class^="v2-spacija-"] {
  cursor: pointer;
  margin: 2px;
  text-align: left;
  color: #0000ff;
  letter-spacing: 0px !important;
  font-weight: normal !important;
}

.state-menu::v-deep *[class^="v2-italik-"] {
  cursor: pointer;
  margin: 2px;
  text-align: left;
  color: #0000ff;
  letter-spacing: 0px !important;
  font-style: normal !important;
  font-weight: normal !important;
}

.state-menu::v-deep *[class^="v2-bold-"] {
  cursor: pointer;
  margin: 2px;
  text-align: left;
  color: #0000ff;
  letter-spacing: 0px !important;
  font-style: normal !important;
  font-weight: normal !important;
}

.state-menu::v-deep *[class^="v2-naslov-"] {
  cursor: pointer;
  margin: 2px;
  text-align: left;
  color: #0000ff;
  letter-spacing: 0px !important;
  font-style: normal !important;
  font-weight: normal !important;
}

.state-menu::v-deep .v2-underline {
  cursor: pointer;
  margin: 2px;
  text-align: left;
  color: #0000ff;
  font-weight: normal !important;
}

.state-menu::v-deep .bold {
  cursor: pointer;
  margin: 2px;
  margin-left: 16px !important;
  text-align: left;
  color: #0000ff;
  font-weight: normal !important;
}

.state-menu::v-deep .clan-margin {
  margin-left: 48px !important;
}

.state-menu::v-deep .italik.clan-margin {
  margin-left: 32px !important;
}

.state-menu::v-deep br {
  display: block !important;
}

.html-container::v-deep .normalize-line-height * {
  text-indent: 0px !important;
}

.html-container::v-deep .law-size-0 {
  font-size: 16px;
}

.html-container::v-deep .law-size-0 * {
  line-height: 19px !important;
}

.html-container::v-deep body.resize-type-em.font-size-80 {
  font-size: 8px;
  line-height: 10px;
}

.html-container::v-deep body.resize-type-em.font-size-85 {
  font-size: 9px;
  line-height: 11px;
}

.html-container::v-deep body.resize-type-em.font-size-90 {
  font-size: 10px;
  line-height: 12px;
}

.html-container::v-deep body.resize-type-em.font-size-95 {
  font-size: 11px;
  line-height: 13px;
}

.html-container::v-deep body.resize-type-em.font-size-100 {
  font-size: 12px;
  line-height: 14px;
}

.html-container::v-deep body.resize-type-em.font-size-105 {
  font-size: 13px;
  line-height: 15px;
}

.html-container::v-deep body.resize-type-em.font-size-110 {
  font-size: 14px;
  line-height: 16px;
}

.html-container::v-deep body.resize-type-em.font-size-115 {
  font-size: 15px;
  line-height: 18px;
}

.html-container::v-deep body.resize-type-em.font-size-120 {
  font-size: 16px;
  line-height: 19px;
}

.html-container::v-deep .h4,
.html-container::v-deep h4 {
  font-size: 18px;
}

.html-container::v-deep .h1,
.html-container::v-deep .h2,
.html-container::v-deep .h3,
.html-container::v-deep .h4,
.html-container::v-deep .h5,
.html-container::v-deep .h6,
.html-container::v-deep h1,
.html-container::v-deep h2,
.html-container::v-deep h3,
.html-container::v-deep h4,
.html-container::v-deep h5,
.html-container::v-deep h6 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

.html-container::v-deep ol,
.html-container::v-deep ul {
  margin-top: 0;
  margin-bottom: 10px;
}

.html-container::v-deep {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 0.75rem !important;
  line-height: 1.42857143;
  color: #000;
  /*    color: #333;
*/
}

.html-container::v-deep element {
  font-size: 100%;
}

.html-container::v-deep .modal-body {
  position: relative;
  padding: 15px;
}

/*
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9 {
    float: left;
}
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
}

.col-lg-12 {
    width: 100%;
}
.col-sm-12 {
    width: 100%;
}
.col-sm-10 {
    width: 83.33333333%;
}
.col-sm-offset-0 {
    margin-left: 0;
}
.col-lg-2 {
    width: 16.66666667%;
}
.col-lg-8 {
    width: 66.66666667%;
}
.col-lg-offset-2 {
    margin-left: 16.66666667%;
}
*/
.html-container::v-deep .list-inline {
  padding-left: 0;
  margin-left: -5px;
  list-style: none;
}

.html-container::v-deep .list-inline > li {
  display: inline-block;
  padding-right: 5px;
  padding-left: 5px;
}

.html-container::v-deep .nav-tabs-green > li {
  background: #dddddd;
  height: 30px;
  vertical-align: middle;
  line-height: 30px;
  color: #0e9606;
  margin: 0 2px;
  padding: 0 15px;
  font-weight: 600;
}

.html-container::v-deep .panel-group {
  margin-bottom: 20px;
}

.html-container::v-deep .panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.html-container::v-deep .panel-default {
  border-color: #ddd;
}

.html-container::v-deep .panel-group .panel {
  margin-bottom: 0;
  border-radius: 4px;
}

.html-container::v-deep .panel-group .panel + .panel {
  margin-top: 5px;
}

.html-container::v-deep * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.html-container::v-deep #topPanelTitle {
  color: #ffffff;
  padding-left: 15px;
  padding-top: 10px;
  margin: 0;
  margin-bottom: 10px;
}

.html-container::v-deep #topPanel {
  background: #f5f5f5;
  background: #9c9c9c;
  background: -webkit-linear-gradient(top, #9c9c9c 0%, #cbcbcb 100%);
  background: -moz-linear-gradient(top, #9c9c9c 0%, #cbcbcb 100%);
  background: -ms-linear-gradient(top, #9c9c9c 0%, #cbcbcb 100%);
  background: -o-linear-gradient(top, #9c9c9c 0%, #cbcbcb 100%);
  background: linear-gradient(to bottom, #9c9c9c 0%, #cbcbcb 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#9c9c9c', endColorstr='#cbcbcb', GradientType=0);
  min-height: 80px;
  border-bottom: 3px solid #ffffff;
  margin-bottom: 5px;
}

.html-container::v-deep .table-panel-green1 {
  border-width: 1px 1px 1px 1px;
  border-style: solid;
  border-color: #dddddd;
  border-radius: 4px;
  box-shadow: none;
  margin-top: 5px;
}

.html-container::v-deep .panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
  color: inherit;
}

.html-container::v-deep .panel-title-green {
  font-size: 14px;
}

.html-container::v-deep .panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.html-container::v-deep .panel-heading-green {
  background: #0e9606;
  background: -webkit-linear-gradient(top, #0e9606 0%, #026105 100%);
  background: -moz-linear-gradient(top, #0e9606 0%, #026105 100%);
  background: -ms-linear-gradient(top, #0e9606 0%, #026105 100%);
  background: -o-linear-gradient(top, #0e9606 0%, #026105 100%);
  background: linear-gradient(to bottom, #0e9606 0%, #026105 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0e9606', endColorstr='#026105', GradientType=0);
  cursor: pointer;
  color: #ffffff !important;
  border-color: #024b03;
}

.html-container::v-deep .panel-group .panel-heading {
  border-bottom: 0;
}

.html-container::v-deep .panel-default > .panel-heading {
  color: #333;
  background-color: #f5f5f5;
  border-color: #ddd;
}

.html-container::v-deep .h5,
.html-container::v-deep h5 {
  font-size: 14px;
}

.html-container::v-deep .row {
  margin-right: -15px;
  margin-left: -15px;
}

.html-container::v-deep p {
  margin: 0 0 10px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 10px;
  margin-left: 0px;
}

.html-container::v-deep .view-act-primary {
  overflow: auto !important;
  padding: 5px;
  border-top: 2px solid #cccccc;
  height: -webkit-calc(100% - 81px);
  height: -moz-calc(100% - 81px);
  height: -o-calc(100% - 81px);
  height: calc(100% - 81px);
}

.html-container::v-deep .panel > .list-group,
.html-container::v-deep .panel > .panel-collapse > .list-group {
  margin-bottom: 0;
}

.html-container::v-deep
  .panel-group
  .panel-heading
  + .panel-collapse
  > .list-group,
.html-container::v-deep
  .panel-group
  .panel-heading
  + .panel-collapse
  > .panel-body {
  border-top: 1px solid #ddd;
}

.html-container::v-deep
  .panel-default
  > .panel-heading
  + .panel-collapse
  > .panel-body {
  border-top-color: #ddd;
}

.html-container::v-deep .list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.html-container::v-deep .list-group-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.html-container::v-deep .panel > .list-group .list-group-item,
.html-container::v-deep
  .panel
  > .panel-collapse
  > .list-group
  .list-group-item {
  border-width: 1px 0;
  border-radius: 0;
}

.html-container::v-deep
  .panel
  > .list-group:first-child
  .list-group-item:first-child,
.html-container::v-deep
  .panel
  > .panel-collapse
  > .list-group:first-child
  .list-group-item:first-child {
  border-top: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.html-container::v-deep
  .panel
  > .panel-heading
  + .panel-collapse
  > .list-group
  .list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.html-container::v-deep a {
  color: #337ab7;
  text-decoration: none;
}

.state-menu::v-deep .clan-margin * {
  text-align: left;
  text-decoration: none !important;
  letter-spacing: 0 !important;
  font-style: normal !important;
}

.html-container::v-deep .force-display-block {
  text-align: left !important;
  font-weight: normal !important;
  margin-top: 0px !important;
}

.html-container::v-deep a[id^="anchor-"] {
  color: #000;
}

/*mora da ostane*/
.html-container::v-deep .naslovMML {
  font-size: 0.92rem;
  font-weight: bold;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  line-height: 1.2rem;
}

.html-container::v-deep .siroka-tabela {
  width: 100%;
  overflow-x: auto;
}

/* .html-container::v-deep p {
  color: #000 !important;
} */
</style>
